module.exports = __webpack_public_path__ + "076fe1f80391738c251f66c421005440.svg";